var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",class:{ 'no--shadow': _vm.$route.meta.flat }},[_c('bottom-bar'),_c('notification-bar'),_c('app-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }